/**
 * This file was auto-generated using @dmp/mono-tools:changelog-converter and should not be manually edited.
 */

import type { PublicChangelogConfig } from '@dmp/shared/public-changelog';

export const publicChangelogConfig = {
    localStorageKey: 'qqms-client-public-changelog',
    releases: [
        
        {
            version: '2.15.1',
            date: '2026-11-02',
            changes: {
                added: undefined,
                changed: undefined,
                fixed: [[{"type":"text","value":"Clearing a custom survey color no longer causes a validation error."}],[{"type":"text","value":"Release notes wait until you sign in before appearing."}],[{"type":"text","value":"Fixed issues that could leave embedded surveys blank or prevent poll results from loading."}]],
                deprecated: undefined,
                removed: undefined,
                security: undefined,
            },
        },

        {
            version: '2.15.0',
            date: '2026-10-20',
            changes: {
                added: [[{"type":"text","value":"Reopen release notes at any time from Changelog in the navigation menu."}]],
                changed: [[{"type":"text","value":"Release notes are easier to browse, with the latest release highlighted."}],[{"type":"text","value":"Repeat-voting polls now show a short waiting message instead of a countdown, then let voters know when to refresh the page to vote again. The cooldown still applies."}]],
                fixed: undefined,
                deprecated: undefined,
                removed: undefined,
                security: undefined,
            },
        },

        {
            version: '2.14.0',
            date: '2026-10-14',
            changes: {
                added: [[{"type":"text","value":"Polls that allow repeat voting now include a short cooldown between votes, with a countdown showing when another vote is available."}]],
                changed: [[{"type":"text","value":"Navigation groups survey, reporting, and admin tools into clearer menus."}]],
                fixed: [[{"type":"text","value":"Embedded surveys and previews keep their intended appearance instead of inheriting styles from the surrounding page."}]],
                deprecated: undefined,
                removed: undefined,
                security: undefined,
            },
        },

        {
            version: '2.13.0',
            date: '2026-10-08',
            changes: {
                added: [[{"type":"text","value":"Search by survey name directly within General Reporting."}],[{"type":"text","value":"An alert banner highlights when active filters are limiting reporting results."}]],
                changed: [[{"type":"text","value":"General Reporting now presents surveys in an alphabetical table view for faster loading and smoother scrolling with large lists."}]],
                fixed: undefined,
                deprecated: undefined,
                removed: undefined,
                security: undefined,
            },
        },

        {
            version: '2.12.0',
            date: '2026-10-05',
            changes: {
                added: [[{"type":"text","value":"Filter the survey list by your own surveys, publication status, or created and updated dates."}],[{"type":"text","value":"Survey list items now display their publication status and placement type at a glance."}]],
                changed: [[{"type":"text","value":"Survey list controls and filters remain pinned to the top of the page while scrolling."}]],
                fixed: [[{"type":"text","value":"Survey dates now consistently display your local calendar date regardless of timezone."}]],
                deprecated: undefined,
                removed: undefined,
                security: undefined,
            },
        },
        ],
} satisfies PublicChangelogConfig;